var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoundationPlayVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8756 53.6303C57.31 53.6304 57.7401 53.545 58.1415 53.3788C58.5428 53.2126 58.9075 52.969 59.2146 52.6618C59.5218 52.3546 59.7654 51.9899 59.9314 51.5885C60.0975 51.1871 60.1829 50.7569 60.1826 50.3225V16.1775C60.1829 15.7431 60.0975 15.3129 59.9314 14.9115C59.7654 14.5101 59.5218 14.1454 59.2146 13.8382C58.9075 13.531 58.5428 13.2874 58.1415 13.1212C57.7401 12.955 57.31 12.8696 56.8756 12.8698H9.62534C9.19091 12.8696 8.76071 12.955 8.35932 13.1212C7.95794 13.2873 7.59323 13.531 7.28604 13.8382C6.97886 14.1454 6.73522 14.5101 6.56906 14.9114C6.40289 15.3128 6.31745 15.743 6.31763 16.1775V50.3225C6.31745 50.757 6.40289 51.1872 6.56906 51.5886C6.73522 51.99 6.97886 52.3547 7.28604 52.6618C7.59323 52.969 7.95794 53.2127 8.35932 53.3788C8.76071 53.545 9.19091 53.6304 9.62534 53.6303H56.8756ZM53.5679 47.0148H12.9317V19.4852H53.5679V47.0148Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1047 33.4416L35.138 38.0387L27.1753 42.6386V24.2473L35.138 28.8478L43.1047 33.4416Z",
    fill: "#E6E6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationPlayVideo);
export default __webpack_public_path__ + "static/media/foundation_play-video.25b7eb7594aa29935d24978e696fb749.svg";
export { ForwardRef as ReactComponent };